<script>
import DataLabel from '@/js/components/common/labels/DataLabel';

export default {
    name: 'LinkLabel',

    functional: true,

    props: {
        link: {type: [String, Object], default: null},
        hideIcon: {type: Boolean},
        showUrl: {type: Boolean},
        noLink: {type: Boolean},
    },

    render(createElement, {props, data, parent}) {
        const item = props.showUrl && props.link && props.link.url
            ? {name: props.link.url}
            : props.link;

        data.props = {
            item: item,
            hideIcon: props.hideIcon,
            iconClass: 'fa fa-fw fa-link',
            none: parent.$t('links.nil'),
        };

        if (!props.noLink && props.link && props.link.url) {
            data.props.href = props.link.url;
            data.props.hrefInNewWindow = true;
        }

        return createElement(DataLabel, data);
    },
};
</script>
